class ShowMap {
	onAdd(map){
		this.map = map;
		this.canvas = this.map.getCanvas();
		this.container = this.createContainer(map);
		this.button = this.addToggleButton();
		return this.container;
		
	}
	onRemove(){
		this.container.parentNode.removeChild(this.container);
		this.map = undefined;
	}
	
	
	 createContainer(parentMap) {
		const container = document.createElement("div")

		container.className = "mapboxgl-ctrl mapboxgl-ctrl-group"

		parentMap.getContainer().appendChild(container)
		return container
	}
	addToggleButton() {
		return this.createButton(
			"mapboxgl-ctrl-show-map ri-fullscreen-line",
			this.container,
			this.toggle,
			this
		)
	}
	toggle() {
		var b = document.querySelector('body');
		
		if(b.classList.contains("full-screen")){
			b.classList.remove("full-screen");
			this.button.classList.replace("ri-fullscreen-exit-fill", "ri-fullscreen-line");
		}
		else{
		
			b.classList.add("full-screen");
			this.button.classList.replace("ri-fullscreen-line", "ri-fullscreen-exit-fill");
		}
		this.resize();
		
	}
	resize(){
		
		this.map.resize();
		
	}
	createButton(className, container, fn, context) {
		const link = document.createElement("button")
		link.className = className

		link.href = "#"
		

		this.onToggleButtonClick = this.toggle.bind(this)
		link.addEventListener("click", this.onToggleButtonClick)

		container.appendChild(link)

		return link
	}
}
export {ShowMap}

